import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M51.59 40.59l-38.72-5.7a46.74 46.74 0 002.69-9.46 7.5 7.5 0 001.88.37l20.82 1.28h.37a6 6 0 00.7-11.91l-25.28-6.6a27.41 27.41 0 00-3.69-5.18A3 3 0 006 7.51c1.25 1.33 4.18 5.25 4.54 9.08a7.62 7.62 0 010 1.48c0 .27-.06.53-.09.8-1 8.52-3.7 17-5.84 18.15a3 3 0 00-1 .89l-.18.16a11.53 11.53 0 008.07 19.71l39.8.17a8.68 8.68 0 00.27-17.36zM16 17a2.5 2.5 0 01.53-1.59L38.06 21h.28l-20.52-1.18a1.47 1.47 0 01-1-.49A5.71 5.71 0 0116 17zm35.3 35l-39.8-.17a5.53 5.53 0 01-.14-11.06l39.54 5.78h.42a2.69 2.69 0 110 5.38zm-36.39-5.78a2.85 2.85 0 11-3-2.69 2.85 2.85 0 013 2.69z",
      stroke: "none"
    })]
  });
};
const IconGymFeature200KitMachine = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "GymFeature200KitMachine__IconGymFeature200KitMachine",
  componentId: "sc-hhey93-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconGymFeature200KitMachine };
